/**
 * Hyllypaikka Fixer
 *
 * Varmistaa että kaikilla ostoskorin tuotteilla on hyllypaikka line item propertynä.
 * Tämä korjaa ongelman kun Wishlist app (tai muut kolmannen osapuolen apit)
 * lisäävät tuotteita ostoskoriin ilman hyllypaikkaa.
 */

class HyllypaikkaFixer {
  constructor() {
    this.processing = false;
    this.init();
  }

  init() {
    // Kuuntele cart:change eventtejä
    document.documentElement.addEventListener('cart:change', (event) => {
      this.checkAndFixShelfLocations(event.detail.cart);
    });

    // Tarkista myös kun sivu ladataan
    this.checkCartOnLoad();
  }

  async checkCartOnLoad() {
    try {
      const cart = await fetch(`${Shopify.routes.root}cart.js`).then(res => res.json());
      await this.checkAndFixShelfLocations(cart);
    } catch (error) {
      console.error('Hyllypaikka fixer: Virhe ostoskorin tarkistuksessa:', error);
    }
  }

  async checkAndFixShelfLocations(cart) {
    // Estä samanaikainen käsittely
    if (this.processing) {
      return;
    }

    this.processing = true;

    try {
      const itemsToFix = [];

      // Tarkista jokainen line item
      for (const item of cart.items) {
        // Jos hyllypaikka puuttuu properties-kentästä
        if (!item.properties || !item.properties._hyllypaikka) {
          // Hae hyllypaikka globaalista objektista
          const shelfLocation = window.productShelfLocations?.[item.key];

          if (shelfLocation) {
            itemsToFix.push({
              key: item.key,
              quantity: item.quantity,
              shelfLocation: shelfLocation
            });
          }
        }
      }

      // Päivitä line itemit joilta puuttuu hyllypaikka
      if (itemsToFix.length > 0) {
        await this.updateLineItems(itemsToFix);
      }
    } catch (error) {
      console.error('Hyllypaikka fixer: Virhe:', error);
    } finally {
      this.processing = false;
    }
  }

  async updateLineItems(itemsToFix) {
    // Hae nykyinen ostoskori ensin
    const cart = await fetch(`${Shopify.routes.root}cart.js`).then(res => res.json());

    // Päivitä line itemit yksi kerrallaan
    for (const itemToFix of itemsToFix) {
      try {
        // Etsi line item nykyisestä ostoskorista
        const currentItem = cart.items.find(item => item.key === itemToFix.key);

        if (!currentItem) {
          continue;
        }

        // Yhdistä nykyiset propertyt ja uusi hyllypaikka
        const updatedProperties = {
          ...(currentItem.properties || {}),
          '_hyllypaikka': itemToFix.shelfLocation
        };

        const response = await fetch(`${Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: itemToFix.key,
            quantity: itemToFix.quantity,
            properties: updatedProperties
          })
        });

        if (response.ok) {
          console.log(`Hyllypaikka fixer: Lisättiin hyllypaikka "${itemToFix.shelfLocation}" tuotteelle`);
        } else {
          console.error('Hyllypaikka fixer: Päivitys epäonnistui:', await response.text());
        }
      } catch (error) {
        console.error('Hyllypaikka fixer: Virhe päivityksessä:', error);
      }
    }

    // Päivitä ostoskori kun kaikki on tehty
    if (itemsToFix.length > 0) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
    }
  }
}

// Alusta kun sivu on ladattu
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new HyllypaikkaFixer();
  });
} else {
  new HyllypaikkaFixer();
}
